import { Button } from '@mui/material';
import useStyles from './AdminMessagesMobileDeleteButton.styles';
import clsx from 'clsx';
import {Delete} from 'components/icons';

type AdminMessagesDeleteButtonPureProps = {
  disabled: boolean;
  handleDeleteMessages: () => void;
};

const AdminMessagesMobileDeleteButton = ({
  disabled,
  handleDeleteMessages,
}: AdminMessagesDeleteButtonPureProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Button
      className={clsx([classes.deleteButton])}
      color='error'
      disabled={disabled}
      onClick={handleDeleteMessages}
    >
      <Delete />
    </Button>
  );
};

export default AdminMessagesMobileDeleteButton;
